// src/components/OrderEntry/constants/orderEntryUi.js
// =============================================================================
// UI CONSTANTS
// =============================================================================
// Extracted from OrderEntry.jsx BLOCK OE.0
// Contains layout dimensions, company options, and min-width values
// =============================================================================

export const COMPANY_OPTIONS = [
  { value: 'tzi', label: 'TZ Medical (TZI)' },
  { value: 'tms', label: 'TZ Monitors (TMS)' },
];

export const ROW_HEIGHT = 32; // approx. one list row height in px

export const LIST_MIN_WIDTH = {
  customer: 300,
  street: 320,
  billTo: 320,
  notes: 350,
  receiving: 500,
};

export const INPUT_HEIGHT = 56;
export const PART_FIELDS_WIDTH = 200;
export const FUTURE_W = 420;
